module.exports = __webpack_public_path__ + "img/Rectangle 23.b81b1b8a.png";